import {
  ENVIRONMENTS,
  getCurrentEnvironment,
  SELECTED_ENVIRONMENT_KEY
} from './environments'

// Priority: 1. EnvironmentSelector (localStorage, explicit user choice), 2. Environment variables (for npm scripts)
const envVars = import.meta.env
const currentEnv = getCurrentEnvironment()
const hasExplicitSelection =
  localStorage.getItem(SELECTED_ENVIRONMENT_KEY) === currentEnv.id

export const API_ENDPOINT = hasExplicitSelection
  ? currentEnv.apiEndpoint
  : envVars.VITE_API_ENDPOINT_URL || currentEnv.apiEndpoint

export const LINREST_API_GATEWAY_URL = hasExplicitSelection
  ? currentEnv.linrestApiGateway
  : envVars.VITE_LINREST_API_GATEWAY_URL || currentEnv.linrestApiGateway

// The ENVIRONMENTS entry the current endpoint belongs to, or undefined when it
// is unlisted (localhost). Undefined is what hides the env selector.
export const CURRENT_ENVIRONMENT = Object.values(ENVIRONMENTS).find(
  environment => environment.apiEndpoint === API_ENDPOINT
)

export const IS_PROD_TIER = CURRENT_ENVIRONMENT?.tier === 'prod'

// BigQuery, SFDC and Zendesk exist only in the US prod region
export const HAS_US_DATA_SOURCES = CURRENT_ENVIRONMENT?.id === 'prod'

export const IS_PROD_EU = CURRENT_ENVIRONMENT?.id === 'prod-eu'

// Org ids differ per region, so org-keyed storage is scoped by env; prod keeps its original unsuffixed keys
const storageEnvId = (CURRENT_ENVIRONMENT ?? currentEnv).id
export const ENV_STORAGE_SUFFIX =
  storageEnvId === 'prod' ? '' : `:${storageEnvId}`

// LinearB app URL for the current environment (api.* → app.*), prod for any other gateway (e.g. localhost)
export const APP_URL = LINREST_API_GATEWAY_URL.includes('//api.linearb')
  ? LINREST_API_GATEWAY_URL.replace('//api.', '//app.')
  : 'https://app.linearb.io'

// prod, prod-eu and dev-01 run the MCP server
export const MCP_URL = `${IS_PROD_TIER ? API_ENDPOINT : ENVIRONMENTS['dev-01'].apiEndpoint}/mcp`

// Per-user/tool MCP usage, errors and Lambda health (prod logs)
export const MCP_USAGE_DASHBOARD_URL =
  'https://app.datadoghq.com/dashboard/98z-bvw-tn5'

// Per-user/action Backoffice UI usage (RUM custom actions)
export const SITE_USAGE_DASHBOARD_URL =
  'https://app.datadoghq.com/dashboard/7ax-wm4-yq6'

// Auth uses the environment variable (set per deployment) with fallback to selected environment
export const AUTH_LINREST_API_GATEWAY_URL =
  envVars.VITE_LINREST_API_GATEWAY_URL || LINREST_API_GATEWAY_URL
